import React, { useState } from 'react';
import { Paper, Typography, Box, IconButton, Collapse } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// 1. Thêm "collapsible = true" vào props
function FormSection({ title, children, defaultExpanded = true, collapsible = true }) {
    const [expanded, setExpanded] =useState(defaultExpanded);

    const handleToggleExpand = () => {
        setExpanded(!expanded);
    };

    return (
        <Paper
            className="input-container-paper"
            variant="outlined"
            sx={{ p: 2.5, mb: 3 }} // Sử dụng style nhất quán
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                // 2. Chỉ mb nếu có title
                mb: (title && (collapsible ? expanded : true)) ? 2 : 0, 
            }}>
                {title && (
                    <Typography className="input-container-title">
                        {title}
                    </Typography>
                )}

                {/* 3. Chỉ hiển thị nút nếu collapsible = true */}
                {collapsible && (
                    <IconButton onClick={handleToggleExpand} size="small">
                        {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                )}
            </Box>

            {/* 4. Luôn mở nếu collapsible = false */}
            <Collapse in={!collapsible || expanded}>
                {children}
            </Collapse>
        </Paper>
    );
}

export default FormSection;